import { Platform } from 'react-native';

// Analytics utility for tracking custom events
class AnalyticsService {
  private track: any = null;

  constructor() {
    if (Platform.OS === 'web') {
      try {
        const { track } = require('@vercel/analytics');
        this.track = track;
      } catch (error) {
        console.warn('Analytics tracking not available:', error);
      }
    }
  }

  // Track custom events
  trackEvent(name: string, properties?: Record<string, any>) {
    if (this.track && Platform.OS === 'web') {
      try {
        this.track(name, properties);
        console.log('📊 Analytics event tracked:', name, properties);
      } catch (error) {
        console.warn('Failed to track event:', error);
      }
    }
  }

  // Predefined event methods for common actions
  trackLogin(method: 'email' | 'verification' | 'google' = 'email') {
    this.trackEvent('user_login', { method });
  }

  trackRegistration() {
    this.trackEvent('user_registration');
  }

  trackEmailVerification(success: boolean) {
    this.trackEvent('email_verification', { success });
  }

  trackFileUpload(fileType: string, hasDescription: boolean) {
    this.trackEvent('file_upload', { 
      file_type: fileType,
      has_description: hasDescription 
    });
  }

  trackFileUploadComplete(fileType: string, duration: number) {
    this.trackEvent('file_upload_complete', { 
      file_type: fileType,
      duration_ms: duration 
    });
  }

  trackFileUploadFailed(fileType: string, error: string) {
    this.trackEvent('file_upload_failed', { 
      file_type: fileType,
      error_type: error 
    });
  }

  trackFileView(fileType: string, source: 'browse' | 'dashboard') {
    this.trackEvent('file_viewed', { 
      file_type: fileType,
      source 
    });
  }

  trackFileDelete(fileType: string) {
    this.trackEvent('file_deleted', { file_type: fileType });
  }

  trackPasswordReset(step: 'request' | 'complete') {
    this.trackEvent('password_reset', { step });
  }

  trackProfileUpdate(field: 'name' | 'email' | 'password') {
    this.trackEvent('profile_update', { field });
  }

  trackScreenView(screenName: string) {
    this.trackEvent('screen_view', { screen_name: screenName });
  }

  trackError(errorType: string, errorMessage: string, context?: string) {
    this.trackEvent('error_occurred', { 
      error_type: errorType,
      error_message: errorMessage,
      context 
    });
  }

  trackFeatureUsage(feature: string, action?: string) {
    this.trackEvent('feature_usage', { 
      feature,
      action 
    });
  }
}

export const analytics = new AnalyticsService(); 